import { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Table from '../../Table/index'
import useDialog from '../../../hooks/useDialog'
import PaymentDetailModal from './PaymentDetailModal'
import { useCurrentWorkspaceBillingHistoryQuery } from '../../../hooks/queries'
import PriceFormat from '../../Text/PriceFormater'
import { customDayjs } from '../../../utils/date'
import { isAnnualPeriod } from '../../../services/payments/annual'
import { formatNumber, formatRowDate } from './CreditPackModal/format'

export default function PaymentHistorySection({ className }) {
  const dialog = useDialog()
  const [page, setPage] = useState(0)
  const pageSize = 10
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sort, setSort] = useState([{ key: 'paidAt', order: 'desc' }])
  // 구독 결제(인보이스)와 크레딧 팩 구매를 결제일 순 한 목록으로 받는다 (화면 전달본 P4)
  const { data: invoices } = useCurrentWorkspaceBillingHistoryQuery({
    page,
    size: pageSize,
    sort: sort[0] ? `${sort[0].key},${sort[0].order}` : undefined,
  })
  const { t } = useTranslation('subscription')
  // const {data:invoices} = useQuery

  // Table 은 row.id 를 key 로 쓴다. 구독 행은 invoiceId, 크레딧 팩 행은 paymentOrderId 라 겹칠 수 있어 type 을 붙인다
  const rows = useMemo(
    () =>
      (invoices?.content ?? []).map((row) => ({
        ...row,
        id: `${row.type}-${row.type === 'CREDIT_PACK' ? row.paymentOrderId : row.invoiceId}`,
      })),
    [invoices],
  )
  const total = invoices?.totalElements ?? 0

  // useEffect(() => {
  //   // todo: get invoices
  //   AivatarClient()
  //     .get(`/workspaces/${workspaceId}/invoices`, {
  //       params: {
  //         page,
  //         size: pageSize,
  //         sort: sort[0] ? `${sort[0].key},${sort[0].order}` : undefined,
  //       },
  //     })
  //     .then((res) => {
  //       setInvoices(res.data)
  //     })
  // }, [page, sort])

  const showPaymentDetail = useCallback(
    (row) => {
      dialog.open(<PaymentDetailModal invoice={row} />)
    },
    [dialog],
  )

  const columns = useMemo(
    () => [
      {
        key: 'paidAt',
        name: t('결제일'),
        className: 'text-left w-[120px]',
        render: (row) => customDayjs(row.paidAt).format('YYYY/MM/DD'),
      },
      {
        key: 'planName',
        name: t('상품'),
        render: (row) =>
          row.type === 'CREDIT_PACK' ? (
            // 구독 결제 행과 구분되는 유일한 표시다. 사용 기한은 환불 신청 기한이기도 하다 (정책 16.9)
            <span className="block text-center">
              {row.grantedCredit != null ? `크레딧 팩 ${formatNumber(row.grantedCredit)}` : row.itemName}
              {row.expiresOn ? (
                <span className="text-gray-21 block text-[12px]">사용 기한 {formatRowDate(row.expiresOn)}까지</span>
              ) : null}
            </span>
          ) : (
            <span translate="no" className="block text-center">
              {row.subscription?.plan.displayName}{' '}
              {isAnnualPeriod(row.subscription) ? t('연간 구독 플랜') : t('월간 구독 플랜')}
            </span>
          ),
      },
      {
        key: 'price',
        name: t('금액'),
        className: 'text-left w-[120px]',
        render: (row) => <PriceFormat amount={row.price} />,
      },
      {
        key: 'detail',
        name: t('청구서'),
        className: 'text-center w-[120px]',
        render: (row) => {
          if (row.type === 'CREDIT_PACK') {
            // 결제대행사(단건 상점) 영수증을 새 창으로 연다. 주소를 받지 못한 결제 건은 링크 없이 행만 보인다
            return row.slipUrl ? (
              <button
                type="button"
                className="text-hyperlink hover:underline"
                onClick={() => window.open(row.slipUrl, '_blank', 'noopener,noreferrer')}
              >
                {t('영수증 보기')}
              </button>
            ) : null
          }
          return (
            <button
              className="text-hyperlink hover:underline"
              onClick={() => {
                showPaymentDetail(row)
              }}
            >
              {t('보기')}
            </button>
          )
        },
      },
    ],
    [showPaymentDetail, t],
  )

  return (
    <section className={className}>
      <span className="text-gray-2 mb-[-60px] block text-[17px] font-bold">{t('결제 이력')}</span>
      <Table
        className={`mt-[-20px] ${className}`}
        columns={columns}
        rows={rows}
        usePagination
        sort={sort}
        page={page}
        onChangePage={setPage}
        pageSize={pageSize}
        total={total}
      />
    </section>
  )
}
